var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCircledInfo1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 11.9995C1 5.92476 5.925 1 12 1C18.075 1 23 5.92476 23 11.9995C23 18.0742 18.075 22.9989 12 22.9989C5.925 22.9989 1 18.0742 1 11.9995Z",
    fill: "#1C1F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8839 8.13354C13.1183 7.89913 13.25 7.5812 13.25 7.2497C13.25 6.91819 13.1183 6.60026 12.8839 6.36585C12.6495 6.13145 12.3315 5.99976 12 5.99976C11.6685 5.99976 11.3505 6.13145 11.1161 6.36585C10.8817 6.60026 10.75 6.91819 10.75 7.2497C10.75 7.5812 10.8817 7.89913 11.1161 8.13354C11.3505 8.36795 11.6685 8.49964 12 8.49964C12.3315 8.49964 12.6495 8.36795 12.8839 8.13354Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2929 10.2924C10.4804 10.1049 10.7348 9.99956 11 9.99956H12C12.2652 9.99956 12.5196 10.1049 12.7071 10.2924C12.8946 10.48 13 10.7343 13 10.9995V16.9992C13 17.2644 12.8946 17.5188 12.7071 17.7063C12.5196 17.8938 12.2652 17.9992 12 17.9992C11.7348 17.9992 11.4804 17.8938 11.2929 17.7063C11.1054 17.5188 11 17.2644 11 16.9992V11.9995C10.7348 11.9995 10.4804 11.8941 10.2929 11.7066C10.1054 11.5191 10 11.2647 10 10.9995C10 10.7343 10.1054 10.48 10.2929 10.2924Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCircledInfo1);
export default __webpack_public_path__ + "static/media/Ic_Circled_Info-1.9710cca55dbf57e54f5a5d7b0479007c.svg";
export { ForwardRef as ReactComponent };